import React from 'react'
import InteractiveDialog from '../../pures/InteractiveDialog/InteractiveDialog'
import { ButtonHLPure } from '../../pures'

const AdministrationTypeDocumentsDeleteWarningModal = ({ onClose, t }) => {
    return (
        <InteractiveDialog
            title={t('configuration.AdministrationTypeDocuments.delete.warning.title')}
            dialogSize='S'
            onClose={onClose}
            CustomButtons={
                <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                    <ButtonHLPure
                        nameBtn={t('button.close') || 'Cerrar'}
                        onClickBtn={onClose}
                    />
                </div>
            }
        >
            <div className='administration-type-documents-delete-warning-modal'>
                <p className='administration-type-documents-delete-warning-modal__text'>
                    {t('configuration.AdministrationTypeDocuments.delete.warning.body')}
                </p>
            </div>
        </InteractiveDialog>
    )
}

export default AdministrationTypeDocumentsDeleteWarningModal
